/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


$(document).ready(function () { 
  
  var slider_small = document.querySelector('.Sale-banner__Slideshow_small');
var sliderWrapper = document.querySelector('.sale_Container_small');

var flkty = new Flickity( slider_small, {
  contain: true,
  dragThreshold: 15,
  adaptiveHeight: true,
  wrapAround: true,
  prevNextButtons: false,
  pageDots: true,
  autoPlay: 4500
});
  

// Initialization

var duration = 3;
var interval = 3;
var slider = document.querySelector('.Sale-banner__Slideshow');
var sliderWrapper = document.querySelector('.sale_Container');
var progressBar = document.querySelector('.progress');

var flkty = new Flickity( slider, {
  contain: true,
  dragThreshold: 15,
  adaptiveHeight: true,
  wrapAround: true,
  prevNextButtons: false,
  pageDots: true
});

// Pause control
var isPaused = false;

sliderWrapper.addEventListener('mouseenter', function() {
  isPaused = true;
});

sliderWrapper.addEventListener('mouseleave', function() {
  isPaused = false;
});

// Main function

var percentTime,
    step,
    tick;

function startProgressbar() {
  resetProgressbar();
  percentTime = 100;
  isPaused = false;
  tick = window.setInterval(increase, interval);
};

function increase() {
  if (!isPaused) {
    step = (duration * 1000) / interval;
    percentTime = percentTime - 100 / step;
    progressBar.style.width = percentTime + "%";
    if ( 0 >= percentTime) {
      flkty.next();
      startProgressbar();
    }
  }
}

function resetProgressbar() {
  progressBar.style.width = 0 + '%';
  clearTimeout(tick);
}

startProgressbar();  
  

  
  
   
    
});

(function() {
  if (window.Flickity) {
    let originalResizeMethod = window.Flickity.prototype.resize,
      lastWidth = window.innerWidth;

    window.Flickity.prototype.resize = function () {
      if (window.innerWidth === lastWidth && this.maxCellHeight > 0) {
        return;
      }

      lastWidth = window.innerWidth;
      originalResizeMethod.apply(this, arguments); // Call original method
    }
  }
})();

(function() {
  window.PhotoSwipe = new Proxy(window.PhotoSwipe, {
    construct(target, args) {
      let instance = new target(...args);

      let originalUpdateSize = instance.updateSize,
        lastWidth = null;

      instance.updateSize = function() {
        if (lastWidth === null || lastWidth !== window.innerWidth) {
          originalUpdateSize(this, arguments);
        }

        lastWidth = window.innerWidth;
      }

      return instance;
    }
  });
})();